import { render } from "./DataChart.vue?vue&type=template&id=b5641eb0&scoped=true"
import script from "./DataChart.vue?vue&type=script&lang=js"
export * from "./DataChart.vue?vue&type=script&lang=js"

import "./DataChart.vue?vue&type=style&index=0&id=b5641eb0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5641eb0"]])

export default __exports__